module.exports = __webpack_public_path__ + "static/media/time.c5a9edcc.svg";